export type Feature = {
  name: string
  enabled: boolean
  value?: string
};

export type FeaturesApiResponse = {
  features: Feature[];
}

export enum ClosedCaptionsTypes {
  SET_CC_VIEW = 'SET_CC_VIEW',
  SET_CC_VIEW_ONLY = 'SET_CC_VIEW_ONLY',
  REARRANGE_CAPTIONS = 'REARRANGE_CAPTIONS',
  REARRANGE_CAPTIONS_SUCCESS = 'REARRANGE_CAPTIONS_SUCCESS',
  REARRANGE_CAPTIONS_FAILURE = 'REARRANGE_CAPTIONS_FAILURE',
  SUBMITING_CAPTION = 'SUBMITING_CAPTION',
  SUBMIT_CAPTION_ERROR = 'SUBMIT_CAPTION_ERROR',
  SUBMIT_CAPTION_SUCCESS = 'SUBMIT_CAPTION_SUCCESS',
  SELECT_CAPTION_UPLOAD = 'SELECT_CAPTION_UPLOAD',
  ADD_CAPTION_UPLOADER = 'ADD_CAPTION_UPLOADER',
  CAPTION_UPLOAD_FAILED = 'CAPTION_UPLOAD_FAILED',
  CAPTION_PROCESS_SUCCESS = 'CAPTION_PROCESS_SUCCESS',
  CAPTION_PROCESSING_STATE = 'CAPTION_PROCESSING_STATE',
  CAPTION_UPLOAD_SUCCESS = 'CAPTION_UPLOAD_SUCCESS',
  CAPTION_UPLOADING_STATE = 'CAPTION_UPLOADING_STATE',
  SAVE_CAPTION_STATUS_INTERVAL = "SAVE_CAPTION_STATUS_INTERVAL",
  SET_VIEW_ONLY = "SET_VIEW_ONLY",
  FETCH_CAPTIONS_SUCCESS = "FETCH_CAPTIONS_SUCCESS",
  FETCH_CAPTIONS_FAILED = "FETCH_CAPTIONS_FAILED",
  FETCH_CAPTIONS = "FETCH_CAPTIONS",
  FETCH_CHANNEL_FEATURES_SUCCESS = 'FETCH_CHANNEL_FEATURES_SUCCESS',
  FETCH_CHANNEL_FEATURES_FAILED = 'FETCH_CHANNEL_FEATURES_FAILED',
  FETCH_CHANNEL_FEATURES = 'FETCH_CHANNEL_FEATURES',
  DELETE_CAPTION_SUCCESS = "DELETE_CAPTION_SUCCESS",
  DELETE_CAPTION_FAILED = "DELETE_CAPTION_FAILED",
  CAPTION_NOT_FOUND = "CAPTION_NOT_FOUND",
  CAPTION_PROCESSING_FAILED = "CAPTION_PROCESSING_FAILED",
  SELECT_CAPTION = "SELECT_CAPTION",
  DELETE_CAPTION = "DELETE_CAPTION",
  UPDATE_CAPTION_CANCELLED_STATE = "UPDATE_CAPTION_CANCELLED_STATE"

}